import { lazy, Suspense } from "react";
import { getStoreType } from "../dynamicController";

const CuciTheme = lazy(() => import("./cuciTheme"));
const LaundroTheme = lazy(() => import("./laundroTheme"));
const CleanProTheme = lazy(() => import("./cleanproTheme"));
const WashupTheme = lazy(() => import("./washupTheme"));

const STORETYPE = getStoreType()

const ThemeController = ({ children }) => {
  return (
    <>
      <Suspense fallback={<></>}>
        {STORETYPE === "cuci" ? (
          <CuciTheme />
        ) : STORETYPE === "washup" || STORETYPE === "jomcuci" ? (
          <WashupTheme />
        ) : (
          <LaundroTheme />
        )}
        {STORETYPE === "cleanpro" && <CleanProTheme />}
      </Suspense>
      {children}
    </>
  );
};

export default ThemeController;
